import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { BooleanService } from 'src/app/core/services/utelize/general/boolean-service';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemParams, DgActionColumnWidth, DgColumnDataType, DgColumnWidths, eSimApiPaths } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DgActionColumn } from 'src/app/core/interfaces/datagrid/dg-action-column';
import { DgApiPath } from 'src/app/core/interfaces/datagrid/dg-api-paths';
import { DgColumn } from 'src/app/core/interfaces/datagrid/dg-column';
import { DgPopup } from 'src/app/core/interfaces/datagrid/dg-pop-up';
import { DgProperties } from 'src/app/core/interfaces/datagrid/dg-properties';
import { EncryptionService } from 'src/app/core/services/utelize/general/encryption-service';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { firstValueFrom } from 'rxjs';
import { GridViewDefaults } from 'src/app/core/grid-view/component/grid-view.defaults';
import { GridViewComponent } from 'src/app/core/grid-view/component/grid-view.component';
import { GridViewService } from 'src/app/core/services/utelize/general/grid-view.service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { UserDTO } from 'src/app/core/models/system/user/user.dto';

const apiPath             =environment.eSimApi+eSimApiPaths.Users + "/" + eSimApiPaths.UsersGetUsersForCompanyIncAssociates;
const exportFilenameSuffix="All-User-Data";
const popUpTitle          ="User";

@Component({
  selector: 'app-users-all-embedded',
  templateUrl: './users-all.component.html',
  styleUrls: ['./users-all.component.scss'],
  providers: [GridViewService]
})

export class UsersAllEmbeddedComponent implements AfterViewInit, OnChanges, OnInit {
  
  @Input() companyId : number | undefined;
  @Input() filterExpr: any;
  
  @Output() gridAddClick : EventEmitter<void>   =new EventEmitter<void>();
  @Output() gridEditClick: EventEmitter<UserDTO>=new EventEmitter<UserDTO>();
  
  @ViewChild('gridView', { static: false }) gridView!: GridViewComponent;

  get embeddedGridHeight() { return this.configSystemService.getValueAsInteger(ConfigSystemParams.ModalGridHeightEmbedded, 420); }
  
  private gridViewDefaults!: GridViewDefaults;
  
  public curUser        : SystemUserDTO;
  public dgApiPath!     : DgApiPath | undefined;
  public dgActionColumn!: DgActionColumn | undefined;
  public dgColumns!     : Array<DgColumn>;
  public dgPopup!       : DgPopup | undefined;
  public dgProperties!  : DgProperties | undefined;
  public gotDgProperties: boolean=false;
  
  constructor(
    private authenticationService     : AuthenticationService,
    private booleanService            : BooleanService,
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private encryptionService         : EncryptionService,
    private exceptionsService         : ExceptionsService
  ) {
    this.curUser         =this.authenticationService.currentUserObject();
    this.gridViewDefaults=new GridViewDefaults(this.authenticationService, this.componentAccessUserService, this.configSystemService, this.exceptionsService);
  }

  public async ngOnInit(): Promise<void> {
    try {
      if (this.companyId==undefined) {
        throw new Error("UsersAllEmbeddedComponent - CompanyID cannot be determined");
      }

      await this.setUpDgApiPaths();
      this.setUpDgActionColumn();
      this.setUpDgColumns();
      this.setUpDgPopup();
      this.setUpDgProperties();

      this.gotDgProperties=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    try {
      if (changes["filterExpr"]) {
        this.applyFilterWhenReady();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyFilterWhenReady(): void {
    try {
      if (!this.gridView?.dataGrid?.instance) {
        setTimeout(() => this.applyFilterWhenReady(), 50);
        return;
      }
    
      //if (this.filterExpr==null || this.filterExpr==undefined)
      //  this.gridView.dataGrid.instance.filter(null);
      //else
        this.gridView.dataGrid.instance.filter(this.filterExpr);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private async setUpDgApiPaths(): Promise<void> {
    try {
      this.dgApiPath            =this.gridViewDefaults.setUpDgApiPaths(apiPath);
      this.dgApiPath!.refreshGet=() => this.setUpDgApiPathGet();

      await this.setUpDgApiPathGet();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private async setUpDgApiPathGet(): Promise<void> {
    try {
      const encResult     =await firstValueFrom(this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>this.companyId, true));
      const companyIdEncSS=encResult.result;

      this.dgApiPath!.get=apiPath + "?companyIdEncSS=" + companyIdEncSS;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgActionColumn() {
    try {
      this.dgActionColumn               =this.gridViewDefaults.setUpDgActionColumn();
      this.dgActionColumn!.allowDeleting=false;
      this.dgActionColumn!.width        =DgActionColumnWidth.oneButtonWithLeftRightPadding;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgPopup() {
    try {
      this.dgPopup               =this.gridViewDefaults.setUpDgPopup(popUpTitle);
      this.dgPopup!.overridePopup=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgProperties() {
    try {
      this.dgProperties               =this.gridViewDefaults.setUpDgProperties("", exportFilenameSuffix + "-" + this.companyId);
      this.dgProperties!.gridKey      ="EmbeddedUsersAll";
      this.dgProperties!.height       =this.embeddedGridHeight;
      this.dgProperties!.pageSize     =10;
      this.dgProperties!.showAddButton=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgColumns() {
    try {
      let dgColumn: DgColumn | undefined;
      
      //ID
      dgColumn             =this.gridViewDefaults.setUpDgColumn("id", "ID", 0, DgColumnDataType.number);
      dgColumn!.formVisible=false;
      dgColumn!.gridVisible=this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridShowId, false);
      dgColumn!.width      =DgColumnWidths.id;
      this.dgColumns       =[dgColumn!];
      
      //Firstname
      dgColumn=this.gridViewDefaults.setUpDgColumn("firstname", "Firstname", "", DgColumnDataType.string);
      this.dgColumns.push(dgColumn!);

      //Lastname
      dgColumn=this.gridViewDefaults.setUpDgColumn("lastname", "Lastname", "", DgColumnDataType.string);
      this.dgColumns.push(dgColumn!);
      
      //Email
      dgColumn       =this.gridViewDefaults.setUpDgColumn("email", "Email", "", DgColumnDataType.string);
      dgColumn!.width=DgColumnWidths.email;
      this.dgColumns.push(dgColumn!);
      
      //SendBill
      dgColumn                =this.gridViewDefaults.setUpDgColumn("sendBill", "Bill", true, DgColumnDataType.boolean);
      // dgColumn!.allowFiltering=false;
      dgColumn!.dataSource    =this.booleanService.idAndDescriptionLookupDataSource();
      dgColumn!.gridVisible   =true;
      dgColumn!.width         =75;
      this.dgColumns.push(dgColumn!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public gridAddButtonClick(e: any) {
    try {
      this.gridAddClick.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public gridEditButtonClick(e: any) {
    try {
      const maybeUser=e.row?.data;

      if (this.isUserDTO(maybeUser)) {
        this.gridEditClick.emit(maybeUser as UserDTO);

      } else {
        throw new Error("UsersAllEmbeddedComponent - Invalid UserDTO");
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private isUserDTO(obj: any): obj is UserDTO {
    try {
      return obj                               &&
             typeof obj.companyID ==="number"  &&
             typeof obj.email     ==="string"  &&
             typeof obj.eSimUser  ==="boolean" &&
             typeof obj.portalUser==="boolean" &&
             typeof obj.username  ==="string";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }
}
